import { useUser } from '@clerk/react-router';
import { useEffect } from 'react';
import {
  useProviderAccountName,
  useSessionClerkUserId,
} from '~/pages/settings/useProviderAccountName';
import { writeProviderNameHint } from './signedInHint';

/**
 * [MCV-1834] Leaves the signed-in provider's MCV profile name where the public header can read it
 * (see `ProviderNameHint`). Renders nothing. Mount inside the user context, under Clerk.
 */
export const ProviderNameHintSync = () => {
  const { user } = useUser();
  const providerName = useProviderAccountName();
  // The profile name comes from the user machine, which follows Clerk with a delay. During a
  // switch between accounts the two briefly name different users, and the hint must never pair
  // one account's name with the other's id.
  const machineClerkUserId = useSessionClerkUserId();
  const clerkUserId = user?.id === machineClerkUserId ? user?.id : undefined;
  const firstName = providerName?.firstName ?? '';
  const lastName = providerName?.lastName ?? '';

  useEffect(() => {
    // Only a loaded profile with a name: a provider still loading, or anyone else, writes nothing.
    if (!clerkUserId || !firstName) return;
    writeProviderNameHint({ clerkUserId, firstName, lastName });
  }, [clerkUserId, firstName, lastName]);

  return null;
};
